module.exports = __webpack_public_path__ + "static/media/ski.d6d36325.avif";